import * as React from "react";
import PropTypes from "prop-types";
import { spinnerService } from "./SpinnerService";
import Loader from "react-loader-spinner";

export class SpinnerComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      show: this.props.hasOwnProperty("show") ? this.props.show : false,
      spinnerService: this.props.spinnerService || spinnerService
    };

    this.state.spinnerService._register(this);
    this.onChangeDisplay = this.onChangeDisplay.bind(this);
  }
  static propTypes = {
    show: PropTypes.bool,
    spinnerService: PropTypes.any
  };
  /**Whether display should be rendered or not */
  onChangeDisplay(display) {
    this.setState({ show: display });
  }
  /**Unregister to SpinnerService */
  componentWillUnmount() {
    this.state.spinnerService._unregister(this);
  }

  render() {
    return (
      <div className={"modal " + (this.state.show ? "is-active" : "")}>
        <div className="modal-background" />
        <div className="modal-content-spinner">
          <div className={"ball-loader"}>
            <div className="ball-loader-ball ball1" />
            <div className="ball-loader-ball ball2" />
            <div className="ball-loader-ball ball3" />
          </div>
        </div>
      </div>
    );
  }
}

SpinnerComponent.propTypes = {
  /**Inherited general props*/
  children: PropTypes.object,
  /**Component given name */
  name: PropTypes.string
};
